import VideoServiceVariantWidget from "../../VideoServiceVariantWidget";

export default function VideoVariantAttachedView() {
  return <VideoServiceVariantWidget />;
}
